export const TABLE_MENU_WIDTH = 280;

export const TABLE_MENU_SELECTOR =
	'[data-testid="column-handle-menu"], [data-testid="row-handle-menu"], [data-toolbar-nested-dropdown-menu]';
